import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['MG', 'Marta G.', 'Buenos Aires', 'Fui al cumpleaños de mi nieta y por primera vez en años comí tranquila, sin preocuparme por cómo iba a terminar la tarde.'], ['SR', 'Silvia R.', 'Córdoba', 'Por fin entendí qué me caía mal. Algo que comía casi todos los días me estaba afectando sin que yo lo supiera.'], ['NP', 'Norma P.', 'Rosario', 'Volví a ponerme el jean que tenía guardado hace dos años. No bajé de peso, simplemente dejé de estar tan hinchada.']] as const;
const extended = [['Marta G.', 'Buenos Aires', '“Hace años que después de almorzar me tenía que desabrochar el pantalón. Desde que empecé el protocolo, terminé varias comidas sin esa incomodidad. Algo tan simple y tan grande al mismo tiempo.”'], ['Silvia R.', 'Córdoba', '“El mapa de disparadores me ayudó a entender que algo que comía casi todos los días me estaba afectando. Nunca lo hubiera relacionado sola. Ahora elijo con mucho más criterio.”'], ['Norma P.', 'Rosario', '“Volví a ponerme el jean que tenía guardado hace dos años. No bajé de peso, simplemente dejé de estar tan hinchada durante el día. Mi marido también lo notó.”'], ['Graciela M.', 'Mendoza', '“Lo que más me cambió fue saber qué comer. Ya no llego a la cena con esa angustia de ‘esto me va a caer mal’. Tengo más tranquilidad y eso se nota en todo.”']] as const;
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-171" data-mp="1z9wc4vsz22ct">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-172" data-mp="291sbsbapi0j5" />)}
    </div>;
}
export function StatsAndProof() {
  const stats = [['+320', 'mujeres aplicando el protocolo'], ['5', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['4.9/5', 'calificación']];
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-173" data-mp="2n2cu76cpluc4">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-174" data-mp="myad62b915kn">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-175" data-mp="iz1i8u4h31ni">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-176" data-mp="wolhhpyuhgs2">{value}</p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-177" data-mp="ry52i1fdln3l">{label}</p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-178" data-mp="16lht44k1ij0u">
        <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-179" data-mp="11orbvdwi1hdu">
          {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-180" data-mp="1flmyk95ob7cd" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-181" data-mp="1ry8khe5l3mdt">
                <div className="grid h-11 w-11 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-182" data-mp="1ryqowy2eh6wt">
                  {initials}
                </div>
                <div data-id="element-183" data-mp="1j4vf3cqc2sau">
                  <h3 className="font-bold" data-id="element-184" data-mp="1j3kgdrbqwaql">{name}</h3>
                  <p className="text-sm text-slate-400" data-id="element-185" data-mp="1n6gub4qcbio7">{place}</p>
                </div>
              </div>
              <div className="mt-5" data-id="element-186" data-mp="196fodav7xl1v">
                <Stars data-id="element-187" data-mp="199k3326b7z6s" />
              </div>
              <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-188" data-mp="1e6u0p53urh5p">“{quote}”</p>
            </motion.article>)}
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-189" data-mp="1495spdh8kd5l">
      <div className="mx-auto max-w-5xl" data-id="element-190" data-mp="2ukk2u6bevvcp">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-191" data-mp="2uipiou7ys79o">
          LO QUE DICEN LAS MUJERES QUE YA LO TIENEN
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-192" data-mp="29ug9i2lzwuem">
          {extended.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-193" data-mp="24x7olu9gqc9o">
              <Stars data-id="element-194" data-mp="1zwk0bgcmc9j5" />
              <p className="mt-2 font-bold" data-id="element-195" data-mp="1zw0h7wb8ff3j">
                {name} <span className="font-normal text-slate-400" data-id="element-196" data-mp="1uz09zi2nc6au">· {place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-197" data-mp="1qwn6z1faamhr">{quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}